// 错误管理的相关方法，可以保存相关错误的堆栈
let crashedEffect = null;
let errStack = [];
import { SAGA_LOCATION } from './innerActionSymbol';

export const push = (frame) => {
	frame.crashedEffect = crashedEffect;
	errStack.push(frame);
};
export const clear = () => {
	crashedEffect = null;
	errStack.length = 0;
};
export const setCrashedEffect = (effect) => {
	crashedEffect = effect;
};

// -- stringify error frame data.
const stringifyFrame = (frame) => {
	const { meta } = frame;
	return `fn [${meta.name}]`;
};
const cancelledTask = (err) => {
	let cancelledTasks = [].concat(...err.map((e) => e.cancelledTasks));
	if (!cancelledTasks.length) {
		return '';
	}
	return ['!!Tasks cancelled due to error:', ...cancelledTasks].join('\n');
};

const effectLocationAsString = (effect) => {
	const location = effect[SAGA_LOCATION];
	// console.log(effect);
	if (location) {
		const { code, fileName, lineNumber } = location;
		return `${code}  ${fileName}[${lineNumber}])}`;
	}
	return `**[${effect.type.toUpperCase()}][${
		effect.payload && effect.payload.action
			? effect.payload.action.type
			: '--UNKNOWN--'
	}]**`;
};

export const toString = () => {
	const [first, ...other] = errStack;
	const crashedEffectLocation = first.crashedEffect
		? effectLocationAsString(first.crashedEffect)
		: null;
	const errorMessage = `The above error occurred in task ${stringifyFrame(first)}${
		crashedEffectLocation ? ` \n when executing effect ${crashedEffectLocation}` : ''
	}`;
	return [
		errorMessage,
		stringifyFrame(first),
		...other.map((o) => `    > ${stringifyFrame(o)}`),
		cancelledTask(errStack),
	].join('\n');
};
